import { render, staticRenderFns } from "./PlantForm.vue?vue&type=template&id=4a9cf416&scoped=true&"
import script from "./PlantForm.vue?vue&type=script&lang=js&"
export * from "./PlantForm.vue?vue&type=script&lang=js&"
import style0 from "./PlantForm.vue?vue&type=style&index=0&id=4a9cf416&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9cf416",
  null
  
)

export default component.exports